
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/sobre-nosaltres",
      function () {
        return require("private-next-pages/3catinfo/sobre-nosaltres/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/sobre-nosaltres"])
      });
    }
  